/**
 * Created by Ivan on 10.08.2026
 */

const StickersRewardWindow2 = function (isFirstReward) {
    const stickers = cleverapps.stickersBook2.newStickers;
    cleverapps.stickersBook2.newStickers = undefined;

    const WindowFactory = Prefab.createWindow("stickers2_reward_window", "stickers2_reward_window_prefab_json", {
        bundles: () => cleverapps.unique(stickers.map((sticker) => SeasonCollectionsHelper2.getCollectionBundleName(sticker.collection.index, sticker.collection.season)))
    });

    return new WindowFactory(isFirstReward, stickers);
};
